import parseInt from 'lodash/parseInt';

const PAGE_SIZE = 30;

export default (mixinOptions = {}) => {
  const useInternalPagination = mixinOptions.useInternalPagination || false;

  return {
    data() {
      return {
        internalPagination: {},
      };
    },
    computed: {
      page() {
        const pageStr = useInternalPagination ?
          this.internalPagination.page : this.$route.query.page;
        return pageStr ? parseInt(pageStr) : 1;
      },
      pageInfo() {
        return { page: this.page, size: PAGE_SIZE };
      },
      pageSize() {
        return PAGE_SIZE;
      },
    },
    methods: {
      resetInternalPagination() {
        this.internalPagination = {};
      },
      redirectFromInvalidPage(pagination) {
        let newPage = null;
        if (!pagination || !pagination.page || pagination.page < 1) {
          newPage = 1;
        } else if (pagination.page > pagination.totalPages) {
          newPage = pagination.totalPages;
        }
        if (newPage) {
          const query = useInternalPagination ?
            this.internalPagination : { ...this.$route.query };
          if (newPage === 1) {
            delete query.page;
          } else {
            query.page = pagination.totalPages;
          }
          if (!useInternalPagination) this.$router.replace({ query });
        }
      },
    },
  };
};



// WEBPACK FOOTER //
// ./mixins/PaginatedView.js